import { useState, useEffect, useRef } from 'react'
import '../../shared/ui/HeaderPanels.css'
import { useAuth } from '../../context/AuthContext'

export default function ProfileDropdown() {
    const { user, logout } = useAuth()

    if (!user) return null

    const initials = [user.first_name, user.last_name]
        .filter(Boolean)
        .map(s => s[0])
        .join('')
        || '?'

    const fullName = [user.first_name, user.last_name].filter(Boolean).join(' ')

    const roleLabel = {
        master: 'Мастер-консультант',
        mechanic: 'Механик',
        ros: 'Руководитель отдела сервиса',
        service_director: 'Директор сервиса',
        master_workshop: 'Мастер цеха',
    }[user.role] || user.role

    return (
        <div style={{ position: 'relative' }}>
            <div
                onClick={e => { e.stopPropagation(); document.dispatchEvent(new CustomEvent('toggle-profile')) }}
                style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#EEF3FF', border: 0, boxShadow: 'inset 0 0 0 1.5px #C9D8FF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '600', color: '#0052FF', cursor: 'pointer', flexShrink: 0, userSelect: 'none' }}
            >
                {initials}
            </div>

            <DropdownMenu
                fullName={fullName}
                roleLabel={roleLabel}
                user={user}
                logout={logout}
            />
        </div>
    )
}

function DropdownMenu({ fullName, roleLabel, user, logout }) {
    const [open, setOpen] = useState(false)
    const openRef = useRef(false)

    useEffect(() => {
        const toggle = () => {
            if (!openRef.current) document.dispatchEvent(new CustomEvent('close-all-panels'))
            openRef.current = !openRef.current
            setOpen(openRef.current)
        }
        const close = () => {
            openRef.current = false
            setOpen(false)
        }
        document.addEventListener('toggle-profile', toggle)
        document.addEventListener('close-all-panels', close)
        document.addEventListener('click', close)
        return () => {
            document.removeEventListener('toggle-profile', toggle)
            document.removeEventListener('close-all-panels', close)
            document.removeEventListener('click', close)
        }
    }, [])

    if (!open) return null

    const initials = [user.first_name, user.last_name].filter(Boolean).map(s => s[0]).join('') || '?'
    return (
        <div onClick={e => e.stopPropagation()} className="hp-panel hp-profile">
            <div className="hp-profile-head">
                <div className="hp-avatar">{initials}</div>
                <div style={{ minWidth: 0 }}>
                    <p className="hp-name">{fullName}</p>
                    <p className="hp-role">{roleLabel}</p>
                </div>
            </div>

            <div className="hp-rows">
                {user.middle_name && <Row icon="id" label="Отчество" value={user.middle_name} />}
                {user.manager && <Row icon="user-star" label="Руководитель" value={user.manager} />}
                {user.salon && <Row icon="building-store" label="Салон" value={user.salon} />}
                {user.phone && <Row icon="phone" label="Телефон" value={user.phone} />}
                {user.max_url && <Row icon="message-circle" label="MAX" value={<a href={user.max_url} target="_blank" rel="noreferrer">Открыть ↗</a>} />}
            </div>

            <button onClick={logout} className="hp-logout"><i className="ti ti-logout" aria-hidden="true" />Выйти</button>
        </div>
    )
}

function Row({ icon, label, value }) {
    return (
        <div className="hp-row">
            <span className="hp-row-icon"><i className={`ti ti-${icon}`} aria-hidden="true" /></span>
            <span className="hp-row-text"><span>{label}</span><b>{value}</b></span>
        </div>
    )
}
